export class AutoTextureConfig {
}
AutoTextureConfig.enableAutoDynamicAtlas = false;
AutoTextureConfig.limitDynamicAtlasSize = 1024;
